import React from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import './styles.scss';
import { LineChar as LineCharConfig } from './configs';

const line = props => {
  const { labels, data: chartData, height } = props;
  const config = new LineCharConfig(labels, chartData);
  return (
    <div className="element-box">
      <div className="el-chart-w">
        <Line
          data={config.data}
          options={config.options}
          styles={config.styles}
          height={height}
        />
      </div>
    </div>
  );
};

line.defaultProps = {
  labels: [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre',
  ],

  height: 100,
};

line.propTypes = {
  labels: PropTypes.array,
  data: PropTypes.array.isRequired,
  height: PropTypes.number,
};

export default line;
